// Generated by KlangScriptProcessor, DO NOT EDIT

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.builder.KlangScriptExtensionBuilder

/**
 * Registers all @KlangScript annotated symbols for the 'stdlib' library.
 */
fun KlangScriptExtensionBuilder.registerStdlibGenerated() {
    registerStdlibBandsBuildersChunk0()
    registerStdlibEffectBuildersChunk0()
    registerStdlibEffectBuildersChunk1()
    registerStdlibIgnitorBuildersChunk0()
    registerStdlibIgnitorBuildersChunk1()
    registerStdlibIgnitorBuildersChunk2()
    registerStdlibIgnitorBuildersChunk3()
    registerStdlibIgnitorBuildersChunk4()
    registerStdlibKatalystBuildersChunk0()
    registerStdlibKatalystBuildersChunk1()
    registerStdlibKatalystBuildersChunk2()
    registerStdlibKlangScriptArrayExtensionsChunk0()
    registerStdlibKlangScriptBooleanExtensionsChunk0()
    registerStdlibKlangScriptConstantsChunk0()
    registerStdlibKlangScriptIgnitorChunk0()
    registerStdlibKlangScriptIgnitorChunk1()
    registerStdlibKlangScriptIgnitorClassicSlotsChunk0()
    registerStdlibKlangScriptIgnitorExtensionsChunk0()
    registerStdlibKlangScriptIgnitorSlotsChunk0()
    registerStdlibKlangScriptKatalystChunk0()
    registerStdlibKlangScriptKatalystSlotsChunk0()
    registerStdlibKlangScriptMathChunk0()
    registerStdlibKlangScriptNumberExtensionsChunk0()
    registerStdlibKlangScriptObjectUtilityChunk0()
    registerStdlibKlangScriptStringExtensionsChunk0()

    // Auto-register documentation for code completion
    (this as? KlangScriptLibrary.Builder)?.docs { registerAll(generatedStdlibDocs) }
}
